// src/components/CreateExerciseDialog.js
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  CircularProgress,
  Box,
} from '@mui/material';
import { createExercise } from '../services/exerciseService';

const CreateExerciseDialog = ({ open, onClose, onSuccess, onNotify }) => {
  const [formData, setFormData] = useState({
    name: '',
    year: new Date().getFullYear(),
    startDate: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await createExercise({
        name: formData.name,
        year: parseInt(formData.year),
        startDate: formData.startDate,
      });
      const created = formData.name;
      setFormData({
        name: '',
        year: new Date().getFullYear(),
        startDate: '',
      });
      if (onNotify) onNotify(`Exercise "${created}" created successfully`, 'success');
      onSuccess();
    } catch (err) {
      const msg = err.response?.data?.message || 'Failed to create exercise';
      setError(msg);
      if (onNotify) onNotify(msg, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setFormData({
        name: '',
        year: new Date().getFullYear(),
        startDate: '',
      });
      setError('');
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Exercise</DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <TextField
            fullWidth
            label="Exercise Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            margin="normal"
            disabled={loading}
            placeholder="e.g., Annual Emolument Verification Exercise"
          />
          <TextField
            fullWidth
            label="Year"
            name="year"
            type="number"
            value={formData.year}
            onChange={handleChange}
            required
            margin="normal"
            disabled={loading}
          />
          <TextField
            fullWidth
            label="Start Date"
            name="startDate"
            type="date"
            value={formData.startDate}
            onChange={handleChange}
            required
            margin="normal"
            disabled={loading}
            InputLabelProps={{ shrink: true }}
            helperText="The exercise will be closed manually when you are done — no end date needed"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Create Exercise'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateExerciseDialog;